export default "__VITE_ASSET__b2f0b322__"